export default __webpack_public_path__ + "static/media/foaccredited.544c8b54.svg";